const Widget_Error = {
  Title: "Something went wrong",
  Description: "Please check your data or configuration and try again.",
};

const widgetDataExceed = (count) => {
  if (!count) {
    count = 500;
  }

  return {
    title: `More than ${count} entries found`,
    description: `Maximum ${count} entries in a single widget for current plan. Try filter entries or upgrade your plan.`
  }
};

const Sort_Total_Items_Exceed = "Sorting is available for result less than 1000, try filter the result before sorting.";

/**
 * 
 * @param {*} name 
 * @returns {string}
 */
const builderNotAvailableMessage = (name) => `Oops... ${name} is not available on preview mode`;
/**
 * 
 * @param {Object} payload
 * @param {Object} payload.error
 * @param {string} payload.message
 * @param {boolean} payload.allowStatusCode
 * @returns {string}
 */
const responseErrorMessage = (payload) => {
  if (payload.error && payload.error.message === 'Network Error' && payload.status === undefined)
    return 'No internet connection. Check your connection and try again'; 
  else if (
    payload.error &&
    payload.error.response && 
    payload.error.response.data && 
    payload.error.response.data.message && 
    (payload.error.response.status === 400 || payload.allowStatusCode)
  )
    return payload.error.response.data.message;
  else if (payload.message)
    return payload.message;
  else
    return 'Something went wrong';
}

export { 
  Widget_Error,
  widgetDataExceed,
  Sort_Total_Items_Exceed,
  builderNotAvailableMessage,
  responseErrorMessage
}